import type { CreditNotesReport, SalesReturnsReport, WalletReport } from '@sellokart/shared';
import { portalApi, queryString } from '@/lib/api';
import type { ReportFilters } from './useReportFilters';

/**
 * Keys sit under `['reports', ...]` so anything that invalidates
 * `reportKeys.all` refreshes these too. Only the range and branch go in the
 * key: search/filters are applied in the browser (see applyClientFilters).
 */
export const returnsWalletKeys = {
  salesReturns: (filters: ReportFilters) =>
    ['reports', 'sales-returns', filters.branchId, filters.from, filters.to] as const,
  creditNotes: (filters: ReportFilters) =>
    ['reports', 'credit-notes', filters.branchId, filters.from, filters.to] as const,
  wallet: (filters: ReportFilters) => ['reports', 'wallet', filters.branchId, filters.from, filters.to] as const,
};

function rangeQuery(filters: ReportFilters): string {
  return queryString({ branchId: filters.branchId, from: filters.from, to: filters.to });
}

export function fetchSalesReturns(filters: ReportFilters, signal?: AbortSignal): Promise<SalesReturnsReport> {
  return portalApi.get<SalesReturnsReport>(`/portal/reports/sales-returns${rangeQuery(filters)}`, { signal });
}

export function fetchCreditNotes(filters: ReportFilters, signal?: AbortSignal): Promise<CreditNotesReport> {
  return portalApi.get<CreditNotesReport>(`/portal/reports/credit-notes${rangeQuery(filters)}`, { signal });
}

export function fetchWallet(filters: ReportFilters, signal?: AbortSignal): Promise<WalletReport> {
  return portalApi.get<WalletReport>(`/portal/reports/wallet${rangeQuery(filters)}`, { signal });
}
